import React from 'react';
import { useTranslation } from 'react-i18next';
import { useWebModalStore } from '@/hooks/useWebModalStore';
import WebModal from '../Modal';
import { isMobile } from '@/biz/tool';
import { Button } from 'aha-components';
import { useDetailDataStore } from '@/hooks/useDetailDataStore';
import { s3ImageUrl } from '@/utils/config';

export default function ModalNotMatchTips() {
  const { t } = useTranslation();
  const { setModalNotMatchInfo, modalNotMatchInfo } = useWebModalStore();
  const { reQueryDetailData, detailData } = useDetailDataStore();
  return (
    <WebModal
      width={isMobile() ? 342 : 560}
      visible={modalNotMatchInfo?.visible}
      isShowFooter={false}
      isShowHeader={false}
      canClose={true}
    >
      <img
        src={`${s3ImageUrl}not-match.png`}
        alt="not-match"
        className="w-[62%] h-auto"
      />
      <div className="self-stretch inline-flex flex-col justify-start items-center gap-2 mt-4">
        <div className="w-96 text-center justify-start text-[#0D0D0D] text-base font-semibold font-['DM_Sans'] leading-6">
          {t('notMatchTips.title', {
            defaultValue: 'So close — just not this campaign'
          })}
        </div>
        <div className="self-stretch flex flex-col justify-center items-center gap-2">
          <div className="self-stretch text-center justify-start text-[#525252] text-sm font-normal font-['DM_Sans'] leading-5">
            {t('notMatchTips.thanks_message', {
              defaultValue: 'Thanks for applying! Your content looks strong. '
            })}
          </div>
          <div className="self-stretch text-center justify-start text-[#525252] text-sm font-normal font-['DM_Sans'] leading-5">
            {t('notMatchTips.quality_message', {
              defaultValue:
                'For this campaign, the brand needs a very specific audience match, and your current audience stats don’t meet that requirement yet.'
            })}
          </div>
          <div className="self-stretch text-center justify-start text-[#525252] text-sm font-normal font-['DM_Sans'] leading-5">
            {t('notMatchTips.new_campaigns_message', {
              defaultValue:
                'Don’t worry — this isn’t a reflection of your quality. New campaigns with different targeting come in all the time.'
            })}
          </div>
          <div className="self-stretch text-center justify-start text-[#525252] text-sm font-normal font-['DM_Sans'] leading-5">
            {t('notMatchTips.brand_looking_for', {
              defaultValue: 'What the brand is looking for: '
            })}
            {modalNotMatchInfo?.message}
          </div>
        </div>
      </div>
      <div className="self-stretch inline-flex justify-center items-center gap-2">
        <Button
          size="small"
          type="primary"
          className={`!w-full mt-8`}
          onClick={() => {
            setModalNotMatchInfo({
              visible: false,
              message: ''
            });
            reQueryDetailData({ orderId: detailData?.order?._id });
          }}
        >
          {t('notMatchTips.got_it', { defaultValue: 'Got it' })}
        </Button>
      </div>
    </WebModal>
  );
}
